import { render, staticRenderFns } from "./SafetyCheck444Index.vue?vue&type=template&id=6a5150c6&scoped=true&"
import script from "./SafetyCheck444Index.vue?vue&type=script&lang=js&"
export * from "./SafetyCheck444Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5150c6",
  null
  
)

export default component.exports